import { cn } from '@shared/lib';

interface SkeletonProps {
  className?: string;
}

export const Skeleton = ({ className }: SkeletonProps) => (
  <div className={cn('bg-secondary animate-pulse rounded', className)} />
);

export const SkeletonList = ({ count = 5, className }: SkeletonProps & { count?: number }) => (
  <div className="space-y-3">
    {Array.from({ length: count }).map((_, i) => (
      <Skeleton key={i} className={cn('h-16', className)} />
    ))}
  </div>
);

export const SkeletonCard = ({ className }: SkeletonProps) => (
  <div className={cn('p-4 rounded-lg border border-border space-y-3', className)}>
    <div className="flex items-center gap-3">
      <Skeleton className="h-10 w-10 rounded-full" />
      <div className="flex-1 space-y-2">
        <Skeleton className="h-4 w-1/3" />
        <Skeleton className="h-3 w-1/4" />
      </div>
    </div>
    <Skeleton className="h-4 w-full" />
    <Skeleton className="h-4 w-2/3" />
  </div>
);

export const SkeletonBar = ({ className }: SkeletonProps) => (
  <Skeleton className={cn('h-10 w-full', className)} />
);
